
import PropTypes from 'prop-types'
import { IconButton } from '@mui/material'

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const ScrollToButton = ({ scrollToRef, scrollDirection = 'down' }) => {

  const scrollToBottom = () => {
    if (scrollToRef.current) {
      scrollToRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }

  return (
    <>
      <IconButton
        aria-label="scroll-to-bottom-btn"
        sx={{
          position: 'fixed',
          zIndex: 99,
          right: 50,
          color: '#263238',
          cursor: 'pointer',
          '@media (max-width: 1200px)': {
            right: 100,
          },
          '@media (max-width: 0px)': {
            right: 50,
          },
          bottom: scrollDirection === 'up' ? 120 : 50
        }}
        color="secondary"
        onClick={scrollToBottom}>
        {scrollDirection === 'up' ? (
          <ArrowUpwardIcon fontSize="large" />
        ) : (
          <ArrowDownwardIcon fontSize="large" />
        )}
      </IconButton>
    </>
  )
}

ScrollToButton.propTypes = {
  scrollToRef: PropTypes.object.isRequired,
  scrollDirection: PropTypes.string
}

export default ScrollToButton
